import { useContext } from 'react';
import { RootStoreContext } from '../stores/root-store';
import { IRootStore, IStores } from '@shared/types';

export const useStores = () => useContext(RootStoreContext);
export const useRootStore = (): IRootStore => useStores();

export const useStoreByName = <K extends keyof IStores>(name: K): IStores[K] => {
  const stores = useStores().stores;
  return stores[name];
};
